"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class ConfirmOrgInvite extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'confirmOrgInvite';
        this._orgPermission = initParams.org_permission;
        this._emailAddress = initParams.email_address;
        this._code = initParams.code;
        this._name = initParams.name;
        this._jobRole = initParams.job_role;
        this._password = initParams.password;
    }
    set orgPermission(value) {
        console.error('Do not set objects this way');
    }
    get orgPermission() {
        return this._orgPermission;
    }
    set emailAddress(value) {
        console.error('Do not set objects this way');
    }
    get emailAddress() {
        return this._emailAddress;
    }
    set code(value) {
        console.error('Do not set objects this way');
    }
    get code() {
        return this._code;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    get name() {
        return this._name;
    }
    set jobRole(value) {
        console.error('Do not set objects this way');
    }
    get jobRole() {
        return this._jobRole;
    }
    set password(value) {
        console.error('Do not set objects this way');
    }
    get password() {
        return this._password;
    }
}
exports.default = ConfirmOrgInvite;
//# sourceMappingURL=confirmOrgInvite.js.map